import { getStorageDays } from '../../util'
import { ViabilityForm } from '../../components/ViabilityForm'
import { FormField } from '../../components/FormField'
import { createFileRoute } from '@tanstack/react-router'

type FormData = {
  initialViability: string
  finalViability: string
}

const StorageTimeCalculator = () => (
  <ViabilityForm<FormData>
    title="Predict Storage Time"
    calculation={getStorageDays}
    renderExtraFields={({ register }) => (
      <>
        <FormField
          label="Initial Viability %"
          registerProps={register('initialViability', {
            required: true,
            min: { value: 0, message: 'Value must be between 0 and 100' },
            max: { value: 100, message: 'Value must be between 0 and 100' },
          })}
        />
        <FormField
          label="Final Viability %"
          registerProps={register('finalViability', {
            required: true,
            min: { value: 0, message: 'Value must be between 0 and 100' },
            max: { value: 100, message: 'Value must be between 0 and 100' },
          })}
        />
      </>
    )}
    renderResultComponent={(result) => (
      <>
        <h3 className="text-lg font-bold">{result.toFixed(1)} days</h3>
        {result > 365 && (
          <h3 className="text-lg font-bold">
            {(result / 365).toFixed(1)} years
          </h3>
        )}
      </>
    )}
    info="This tool is based on the viability equations of Ellis and Roberts (1980). It predicts the length of time a seed lot can be stored for viability (%) to fall from the entered initial value to the entered final value, depending on the species and the storage moisture content and temperature. For example, it may be of interest to predict how long a seed lot can be stored in a genebank before the viability falls to the viability threshold."
  />
)

export const Route = createFileRoute('/viability/storage-time')({
  component: StorageTimeCalculator,
})
